import React, { useEffect, useMemo, useState } from 'react'
import styles from "./styles.module.scss"
import PaymentSplitButton from './PaymentSplitButton'
import CustomPartialPayment from './CustomPartialPayment'
import PartialPaymentMethods from './PartialPaymentMethods'
import { Switch, Tag } from 'antd'
import { FormCheckbox } from 'components/FormItems/FlatFormItems'
import { MERCHANT } from 'utils/enums'
import { useDispatch } from 'react-redux'
import { changeWalletPreferance, updateOrderPaymentStatus } from 'services/booking.service'
import { Checkbox } from 'antd';


// const WIDGET_TYPE = {
//     FULL: 1,
//     SPLIT: 2
// }

export const SPLIT = {
    FULL: 1,
    HALF: 2,
    THIRD: 3,
    QUATER: 4,
    CUSTOM: 0
}

export default function PartialPayments({ total, customerId, order,
    splitType, setSplitType,
    paymentMethod, setPaymentMethod,
    customSplitAmount, setCustomSplitAmount,
    defaultPaymentMethod,
    paymentMethods,
    fetchingPaymentMethods,
    refetchPaymentMethods,
    handleUseWalletChecked,
    wallets,
    isCustomerWalletsLoading,
    isSplitPayment,
    setIsSplitPayment,
    lockSplitPayment,
    handleSubmit,
    handleCharge,
    transactionsHistory,
    disabled
}) {

    const dispatch = useDispatch()

    return (
        <div style={{ padding: "8px 0px" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <p className={styles.messageText} style={{ margin: 0 }}>Select Payment</p>

                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {/* <p style={{margin: 0}}>Full</p> */}
                    <Switch checked={isSplitPayment}
                        disabled={typeof lockSplitPayment === 'number' || disabled}
                        onChange={async (checked) => {
                            setSplitType(SPLIT.FULL)
                            setCustomSplitAmount(0)
                            setIsSplitPayment(checked)

                            if (checked === false && paymentMethod?.merchant === MERCHANT.Wallet)
                                setPaymentMethod(defaultPaymentMethod ? { merchant: MERCHANT.Stripe, paymentMethodId: defaultPaymentMethod } : { merchant: MERCHANT.Cash })

                            if (checked) {
                                // remove use wallet if switching to split payment
                                if (order?.useWallet) {
                                    dispatch(changeWalletPreferance(order?.orderId, false, undefined, undefined,
                                        () => setIsSplitPayment(false)
                                    ));
                                }

                                // also remove cash if switching to split payment
                                if (order?.merchant === MERCHANT.Cash) {
                                    await dispatch(updateOrderPaymentStatus(order, 2));
                                }
                            }

                        }} />
                    <p style={{ margin: 0 }}>Split</p>
                </div>
                {/* <Tag color="gold" style={{ cursor: 'pointer' }} onClick={() => {
                    setSplitType(SPLIT.FULL)
                    setCustomSplitAmount(0)
                    setIsSplitPayment(prev => !prev)
                }}>Switch to {isSplitPayment ? "Full" : "Split"} Payment</Tag> */}
            </div>
            <div className={styles.splitsContainer}>
                <PaymentSplitButton
                    text="Pay Full Amount"
                    amount={Number(total / 1).toFixed(2)}
                    onClick={() => {
                        setSplitType(SPLIT.FULL)
                    }}
                    selected={splitType === SPLIT.FULL}
                    // greyedOut={splitType === SPLIT.CUSTOM}
                    disabled={typeof lockSplitPayment === 'number' && lockSplitPayment !== SPLIT.FULL}
                />
                {
                    !isSplitPayment && <Checkbox
                        className={styles.useWalletCheckbox}
                        // hidden={
                        //     credit === 0 && !(isOrderCompleted && total?.giftcard > 0)
                        // }
                        checked={order?.useWallet}
                        name="useWallet"
                        label="Use Wallet"
                        disabled={
                            isCustomerWalletsLoading || disabled
                        }
                        onChange={async (e) => {
                            console.log("e", e.target.checked);
                            const checked = e.target.checked;
                            if (checked === true) {
                                handleUseWalletChecked();
                            } else
                                dispatch(changeWalletPreferance(order?.orderId, checked));
                        }}
                    >
                        Use Wallet
                    </Checkbox>
                }
                {
                    isSplitPayment && <>
                        <PaymentSplitButton
                            text="Pay Half (1/2)"
                            amount={Number(total / 2).toFixed(2)}
                            onClick={() => {
                                setSplitType(SPLIT.HALF)
                            }}
                            selected={splitType === SPLIT.HALF}
                            // greyedOut={splitType === SPLIT.CUSTOM}
                            disabled={typeof lockSplitPayment === 'number' && lockSplitPayment !== SPLIT.HALF}
                        />
                        <PaymentSplitButton
                            text="Pay Third (1/3)"
                            amount={Number(total / 3).toFixed(2)}
                            onClick={() => {
                                setSplitType(SPLIT.THIRD)
                            }}
                            selected={splitType === SPLIT.THIRD}
                            // greyedOut={splitType === SPLIT.CUSTOM}
                            disabled={typeof lockSplitPayment === 'number' && lockSplitPayment !== SPLIT.THIRD}
                        />
                        <PaymentSplitButton
                            text="Pay Quater (1/4)"
                            amount={Number(total / 4).toFixed(2)}
                            onClick={() => {
                                setSplitType(SPLIT.QUATER)
                            }}
                            selected={splitType === SPLIT.QUATER}
                            // greyedOut={splitType === SPLIT.CUSTOM}
                            disabled={typeof lockSplitPayment === 'number' && lockSplitPayment !== SPLIT.QUATER}
                        />
                        <CustomPartialPayment onClick={() => {
                            setSplitType(SPLIT.CUSTOM)
                        }}
                            selected={splitType === SPLIT.CUSTOM}

                            customAmount={customSplitAmount}
                            setCustomAmount={setCustomSplitAmount}

                        />
                    </>
                }

                <PartialPaymentMethods
                    isMobile={order?.operationTypeId === 1}
                    orderId={order?.orderId}
                    customerId={order?.customerId}
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                    defaultPaymentMethod={defaultPaymentMethod}
                    paymentMethods={paymentMethods}
                    fetchingPaymentMethods={fetchingPaymentMethods}
                    refetchPaymentMethods={refetchPaymentMethods}
                    handleUseWalletChecked={handleUseWalletChecked}
                    showWalletOption={isSplitPayment}
                    wallets={wallets}
                    handleSubmit={handleSubmit}
                    handleCharge={handleCharge}
                    isSplitPayment={isSplitPayment}
                    transactionsHistory={transactionsHistory}
                    disabled={disabled}
                />
            </div>
        </div>
    )
}
